import axios from 'axios';

export default {
  data() {
    return {
      type: `${this.$options.name}-${this.$root.year}`,
      userID: null,
      submission: null,
      schema: null,
      step: 'login',
      createAccount: true,
      loading: false,
      username: '',
      password: '',
      promoLoading: false,
      mapIcon: {
        url: require('../../assets/img/pin.svg'),
        labelOrigin: {x: 30, y: 12}
      },
      didUseMap: false,
    }
  },
  mounted() {
    this.getFieldSchema();

    if (this.$route.query.id) {
      this.userID = this.$route.query.id;
    }
  },
  watch: {
    // Validators
    submission: {
      handler(submission) {
        this.validate(submission);
      },
      deep: true,
    },
    'submission.tour_address': {
      handler(newVal, oldVal) {
        if (oldVal === undefined) return;
        this.handleAddressChange();
      }
    },
    'submission.tour_city': {
      handler(newVal, oldVal) {
        if (oldVal === undefined) return;
        this.handleAddressChange();
      }
    },
    'submission.tour_state': {
      handler(newVal, oldVal) {
        if (oldVal === undefined) return;
        this.handleAddressChange();
      }
    },
    'submission.tour_zip': {
      handler(newVal, oldVal) {
        if (oldVal === undefined) return;
        this.handleAddressChange();
      }
    },
  },
  methods: {
    async login(e, step) {
      this.loading = true;

      try {
        let loginCredentials = {
          username: this.username,
          password: this.password,
        }
        if (localStorage.getItem('userID')) loginCredentials.userID = localStorage.getItem('userID');

        let wordpressUser = await axios({
          method: 'POST',
          url: `${this.$root.api_url}login?userType=${this.type}${this.$route.query.invitecode ? `&invitecode=${this.$route.query.invitecode}` : ''}`,
          data: loginCredentials,
        });

        this.userID = wordpressUser.data.id;
        this.submission = wordpressUser.data;
        localStorage.setItem('userID', wordpressUser.data.id);
        await this.syncUser();
        this.step = step ? step : 0;
        this.loading = false;
        window.scrollTo(0, 0);
      } catch (error) {
        this.loading = false;
        this.step = 'login';
        alert(error.response.data);
        console.log(error.response.data);
        localStorage.removeItem('userID');
        location.reload();
      }
    },
    logout() {
      localStorage.removeItem('userID');
      location.href = location.href.split('?')[0];
      location.reload();
    },

    async nextStep() {
      await this.syncUser();
      this.step++;
      this.validate();
      window.scrollTo(0, 0);
    },
    prevStep() {
      this.step--;
      window.scrollTo(0, 0);
    },

    async syncUser(promo) {
      if (!promo) this.loading = true;
      let wordpressUser = await axios({
        method: 'PUT',
        url: this.$root.api_url + 'updateUser?userType=' + this.type + '&postID=' + this.userID,
        data: this.submission,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      this.submission = wordpressUser.data;
      this.loading = false;
    },
    async verifyPromo() {
      this.promoLoading = true;
      await this.syncUser(true);
      this.promoLoading = false;
      if (this.submission.submission_fee > 0) {
        alert('That promo code is invalid.');
      }
    },
    async coverFees() {
      this.submission.cover_fees = !this.submission.cover_fees;
      await this.syncUser(true);
    },
    async getFieldSchema() {
      let wordpressSchema = await axios({
        method: 'OPTIONS',
        url: 'https://admin.austinstudiotour.org/wp-json/wp/v2/' + this.type,
      });
      this.schema = wordpressSchema.data.schema.properties.acf.properties;
    },
    async verifyCheckoutSuccess() {
      try {
        await axios({
          method: 'GET',
          url: this.$root.api_url + 'checkoutVerify?userType=' + this.type + '&id=' + this.$route.query.id + '&session_id=' + this.$route.query.session_id,
        });

        this.loading = false;
        this.step = 'checkout_success';
      }
      catch (error) {
        this.loading = false;
        this.step = 'checkout_error';
        alert(error.response.data);
        console.log(error.response.data);
      }
    },
    async finish() {
      this.submission.status = 'Pending Review';
      await this.syncUser();
      this.step = 'finish';
    },

    // File handling
    prepareUploadFile(e, field, index) {
      //50000 bytes
      if (e.target.files[0].size < 50000) {
        alert('Image is too small, choose a larger image');
        e.target.value = '';
        return;
      }

      if (field === 'artwork') {
        this.submission.artwork[this.currentArtwork].images[index].image = {url: 'Uploading...'};
      } else if (field === 'studio') {
        this.submission.studio_images[index].image = {url: 'Uploading...'};
      } else if (field === 'events_featured') {
        let currentEvent = this.submission.events.findIndex(event => event.id == this.currentEvent);
        console.log(this.submission.events);
        this.submission.events[currentEvent].featured_images[index].image = {url: 'Uploading...'};
      } else {
        this.submission[field] = {url: 'Uploading...'};
      }

      let formData = new FormData();
      formData.append('post', this.userID);
      formData.append('file', e.target.files[0]);
      this.uploadFile(formData, field, index);
    },

    async uploadFile(formData, field, index) {
      this.loading = true;

      try {
        let uploadedFile = await axios({
          method: 'POST',
          url: `${this.$root.api_url}uploadFile?type=${this.type}`,
          data: formData,
        });

        if (field === 'artwork') {
          this.submission.artwork[this.currentArtwork].images[index].image = uploadedFile.data;
        } else if (field === 'studio') {
          this.submission.studio_images[index].image = uploadedFile.data;
        } else if (field === 'events_featured') {
          let currentEvent = this.submission.events.findIndex(event => event.id == this.currentEvent);
          this.submission.events[currentEvent].featured_images[index].image = uploadedFile.data;
        } else {
          console.log('File uploaded', uploadedFile.data);
          this.submission[field] = uploadedFile.data;
        }

        await this.syncUser();
      } catch (error) {
        this.loading = false;
        console.log(error.response.data);
        alert(error.response.data);
        this.deleteFile(null, field, index);
      }
    },
    async deleteFile(event, field, index) {
      if (field === 'artwork') {
        this.submission.artwork[this.currentArtwork].images[index].image = false;
      } else if (field === 'studio') {
        this.submission.studio_images[index].image = false;
      } else if (field === 'events_featured') {
        let currentEvent = this.submission.events.findIndex(event => event.id == this.currentEvent);
        this.submission.events[currentEvent].featured_images[index].image = false;
      } else {
        this.submission[field] = '';
      }

      await this.syncUser();
    },

    handleAddressChange() {
      if (this.submission.tour_address && this.submission.tour_city &&
          this.submission.tour_state && this.submission.tour_zip && this.submission.tour_zip.length === 5) {
        this.geocode(this.submission);
      }
    },
    mapClick(e) {
      this.submission.coordinates = `${e.latLng.lat()},${e.latLng.lng()}`;
      this.didUseMap = true;
    },
    resetMap() {
      this.geocode(this.submission);
      this.didUseMap = false;
    },
    async geocode(submission) {
      let address = encodeURIComponent(submission.tour_address + ' ' + submission.tour_city + ' ' + submission.tour_state + ' ' + submission.tour_zip);

      try {
        const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address='${address}'&key=AIzaSyBi0L5ZEekb6yQR9Kfj_zKE5bCOjWEAtGA`);
        const geocode = response.data;

        if (geocode.results.length && geocode.results[0].geometry) {
          this.submission.coordinates = `${geocode.results[0].geometry.location.lat},${geocode.results[0].geometry.location.lng}`;
          console.log(this.submission.coordinates);
        }
      } catch (error) {
        console.error('Error fetching geocode:', error);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/Forms/Forms.js